import type { GameController } from './controller';

export interface KeyboardCapture {
  enabled: boolean;
  clearCaptures(): void;
}

function textFieldFocused(): boolean {
  const node = document.activeElement;
  if (!node || !(node instanceof HTMLElement)) return false;
  if (node.isContentEditable) return true;
  if (node.tagName === 'TEXTAREA') return true;
  if (node.tagName !== 'INPUT') return false;
  const type = (node as HTMLInputElement).type;
  return type !== 'button' && type !== 'checkbox' && type !== 'radio' && type !== 'submit' && type !== 'file' && type !== 'range';
}

/** Drop Phaser key capture while a report or any text field is being typed in. */
export function watchGameKeyboard(controller: GameController, keyboard: KeyboardCapture): () => void {
  const sync = (): void => {
    if (controller.feedbackOpen || textFieldFocused()) {
      keyboard.enabled = false;
      keyboard.clearCaptures();
      return;
    }
    keyboard.enabled = true;
  };
  const unsub = controller.subscribe(() => sync());
  const onFocus = (): void => sync();
  const onBlur = (): void => {
    queueMicrotask(sync);
  };
  document.addEventListener('focusin', onFocus);
  document.addEventListener('focusout', onBlur);
  sync();
  return () => {
    unsub();
    document.removeEventListener('focusin', onFocus);
    document.removeEventListener('focusout', onBlur);
  };
}
